<template>
  <div id="news">
    <navigation></navigation>
    <banner mainen="NEWS" mainzh="集团新闻"></banner>
    <div class="container">
      <div class="main-list">
        <div class="mode-title">
          企业新闻<span class="mode-title-en">News</span>
        </div>
        <div class="news-list">
          <div class="one" v-for="item in newslist" :key="item.id">
            <a :href="'/#/detail/'+ item.id ">
            <div class="list-container">
              <div class="show-image">
                <img :src="item.image" alt="" />
              </div>
              <div class="content">
                <div class="top-content">
                  <div class="news-title">
                    {{ item.newsname }}
                  </div>
                  <div class="news-date">
                    <div class="news-date-year">{{item.year}}</div>
                    <div class="news-date-day">{{item.day}}</div>
                  </div>
                </div>
                <div class="bottom-content">
                  <div class="news-summary">
                    {{ item.summary }}
                  </div>
                </div>
              </div>
            </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <vfooter></vfooter>
  </div>
</template>
<script>
import navigation from "@/components/sub/Nav";
import vfooter from "@/components/sub/Footer";
import banner from "@/components/sub/Banner";
export default {
  name: "news",
  components: {
    navigation,
    vfooter,
    banner,
  },
  data() {
    return {
      newslist:[],
    };
  },
  mounted(){
    this.getData();
  },
  methods:{
    getData() {
      this.axios
        .get(
          this.$host + "/api/news/list"
        )
        .then((res) => {
          this.newslist = res.data.data;
          console.log(res.data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  }
};
</script>
<style scoped>
#news {
  position: flex;
  justify-content: center;
}
#news .container {
    width:1200px;
}

#news .main-list {
  padding: 45px 0 72px 0;
}

#news .main-list .mode-title {
  font-size: 28px;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
}

#news .main-list .mode-title .mode-title-en {
  padding-left: 13px;
  font-size: 14px;
  font-weight: 600;
  color: #999999;
  line-height: 30px;
  opacity: 0.5;
}

#news .main-list .news-list{

    margin-top: 60px;
}
#news .main-list .news-list .one {
  width: 100%;
  height: 230px;
}
#news .main-list .news-list .one .list-container {
  padding: 20px 30px 20px 20px;
  display: flex;
  justify-content: space-between;
}

#news .main-list .news-list .one .show-image,
#news .main-list .news-list .one .show-image img {
  width: 316px;
  height: 190px;
}

#news .main-list .news-list .one .content {
  width: 800px;
}
#news .main-list .news-list .one .content .top-content {
  display: flex;
  justify-content: space-between;
  padding-top: 17px;
}
#news .main-list .news-list .one .content .top-content .news-title {
  width: 700px;
  height: 60px;
  overflow: hidden;
  font-size: 22px;
  font-weight: 600;
  color: #333333;
  line-height: 30px;
}

#news .main-list .news-list .one .content .top-content .news-date {
  text-align: right;
}
#news
  .main-list
  .news-list
  .one
  .content
  .top-content
  .news-date
  .news-date-year {
  width: 49px;
  height: 22px;
  font-size: 29px;
  font-family: Arial Narrow;
  font-weight: bold;
  color: #999999;
  line-height: 39px;
}

#news
  .main-list
  .news-list
  .one
  .content
  .top-content
  .news-date
  .news-date-day {
  margin-top: 10px;
  height: 13px;
  font-size: 17px;
  font-weight: 400;
  color: #999999;
  line-height: 23px;
}

#news .main-list .news-list .one .content .bottom-content .news-summary {
  width: 758px;
  height: 81px;
  margin-top: 20px;
  overflow: hidden;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 27px;
}

#news .main-list .news-list .one:hover {
  background-color: #175cc0;
}

#news .main-list .news-list .one:hover .content .top-content .news-title {
  color: #fff;
}

#news .main-list .news-list .one:hover .content .top-content .news-date-year {
  color: #e0e0e0;
}
#news .main-list .news-list .one:hover .content .top-content .news-date-day,
#news .main-list .news-list .one:hover .content .bottom-content .news-summary {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/page/News.vue